import { z } from 'zod';

export const SAddressInputRequest = z.object({
  delete: z.array(z.any()),
  upsert: z.array(
    z.object({
      model: z.string(),
      data: z.array(
        z.object({
          id: z.union([z.string(), z.number(), z.null()]).optional(),

          // MemberAddress fields
          is_main_address: z.boolean().optional(),
          fk_model: z
            .object({
              member: z.number().optional(),
            })
            .nullable()
            .optional(),
          type: z.number().optional().nullable(),
          place: z.string().optional().nullable(),
          recipient_name: z.string().optional().nullable(),
          phone_number: z.string().optional().nullable(),
          address: z.string().optional().nullable(),
          master_provinsi_code: z.string().optional().nullable(),
          master_kota_kabupaten_code: z.string().optional().nullable(),
          master_kecamatan_code: z.string().optional().nullable(),
          master_kelurahan_code: z.string().optional().nullable(),
          rt: z.string().optional().nullable(),
          rw: z.string().optional().nullable(),
          zip_code: z.string().optional().nullable(),

          // DummyModel fields
          locations: z
            .array(
              z.object({
                longitude: z.number().nullable(),
                latitude: z.number().nullable(),
              })
            )
            .optional(),
        })
      ),
    })
  ),
});

export const STorajaDeleteRequest = z.object({
  delete: z.array(
    z.object({
      id: z.array(z.number()).optional(),
      form_index: z.any().optional(),
      model: z.string().optional(),
    })
  ),
  upsert: z.array(z.any()),
});

export const SPasswordChangeRequest = z.object({
  pass: z.string(),
  password: z.string(),
});

export const SBpjsInputRequest = z.object({
  delete: z.array(z.any()),
  upsert: z.array(
    z.object({
      model: z.string(),
      data: z.array(
        z.object({
          id: z.number(),
          bpjs_ketenagakerjaan_number: z.string().nullable().optional(),
          bpjs_number: z.string().nullable().optional(),
          fk_model: z.object({
            user: z.number(),
          }),
        })
      ),
    })
  ),
});

export const SEmergencyContactInputRequest = z.object({
  delete: z.array(z.any()),
  upsert: z.array(
    z.object({
      model: z.string(),
      data: z.array(
        z.object({
          id: z.union([z.string(), z.number(), z.null()]).optional(),
          name: z.string(),
          relation: z.number(),
          phone_number: z.string(),
          individual_id: z.number().optional(),
          fk_model: z
            .object({
              individual: z.number().optional().nullable(),
            })
            .nullable()
            .optional(),
        })
      ),
    })
  ),
});

export const SEKTPInputRequest = z.object({
  nik: z.string(),
  nickname: z.string(),
  birth_day: z.number(),
  birth_month: z.number(),
  birth_year: z.number(),
  birthplace: z.string(),
  gender: z.number(),
  blood_type: z.number(),
  marital_status: z.number(),
  agama_int: z.number(),
  citizenship: z.string(),
  identity_address: z.string(),
  provinsi: z.string(),
  rt: z.string(),
  rw: z.string(),
  kota_kabupaten: z.string(),
  kecamatan: z.string(),
  kelurahan: z.string(),
  body: z.object({}),
});

export type TAddressInputRequest = z.infer<typeof SAddressInputRequest>;
export type TTorajaDeleteRequest = z.infer<typeof STorajaDeleteRequest>;
export type TPasswordChangeRequest = z.infer<typeof SPasswordChangeRequest>;
export type TBpjsInputRequest = z.infer<typeof SBpjsInputRequest>;
export type TEmergencyContactInputRequest = z.infer<
  typeof SEmergencyContactInputRequest
>;
export type TEKTPInputRequest = z.infer<typeof SEKTPInputRequest>;
